import { toast } from "bulma-toast";

class ToastUtils {
  constructor() { }

  defaultToast(message, type, position) {
    toast({
      message,
      position: position,
      type,
      pauseOnHover: true,
      opacity: 0.9,
      duration: 3000,
    });
  }

  successToast(message) {
    this.defaultToast(message, "is-success", "top-right");
  }

  infoToast(message) {
    this.defaultToast(message, "is-info", "top-right");
  }

  dangerToast(message) {
    this.defaultToast(message, "is-danger", "top-right");
  }

  alertToast(message) {
    this.defaultToast(message, "is-warning", "top-right");
  }
}

export const toastUtils = new ToastUtils()